import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, QuoteIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const [index, setIndex] = useState(0);
  const current = testimonials[index];
  const go = (direction: 1 | -1) => {
    setIndex(value => (value + direction + testimonials.length) % testimonials.length);
  };
  return <section className="bg-white" data-id="element-356" data-mp="2x1bh3plt7j11">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-357" data-mp="2s1qact0ee6dr">
        <SectionHeading kicker={t(copy.testimonialsKicker)} title={t(copy.testimonialsTitle)} data-id="element-358" data-mp="2s3tai5v9lfw7" />

        <div className="mx-auto mt-12 max-w-3xl" data-id="element-359" data-mp="v7c8xd3zhhsk">
          <div className="relative rounded-3xl border border-navy/10 bg-mist p-8 shadow-card sm:p-12" data-id="element-360" data-mp="qa3r5dmqzfru">
            <QuoteIcon className="h-8 w-8 text-bright/40" aria-hidden="true" data-id="element-361" data-mp="h4wva3k7seiq" />
            <AnimatePresence mode="wait" data-id="element-362" data-mp="m5kkcjovulab">
              <motion.blockquote key={current.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-363" data-mp="m6m73lf9gw7v">
                <p className="mt-4 font-display text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-364" data-mp="zwy33veyvf4a">
                  “{t(current.quote)}”
                </p>
                <footer className="mt-8 flex items-center gap-4" data-id="element-365" data-mp="q766ywr7ydxp">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-royal font-display text-sm font-extrabold text-white" data-id="element-366" data-mp="q4saqkksyvok">
                    {current.initials}
                  </span>
                  <div data-id="element-367" data-mp="1nm0hmueb0ruk">
                    <p className="font-display text-sm font-extrabold text-navy" data-id="element-368" data-mp="1nma8ek76b31b">{current.name}</p>
                    <p className="text-sm text-charcoal/60" data-id="element-369" data-mp="1xi91d5h9j7bf">{t(current.location)}</p>
                  </div>
                  <span className="ml-auto flex items-center gap-0.5" aria-label={`${current.rating} / 5`} data-id="element-370" data-mp="1sjz50rjsy0o8">
                    {Array.from({
                    length: current.rating
                  }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-current text-bright" aria-hidden="true" data-id="element-371" data-mp="1jkkfpvfdfw5b" data-mpi={star} />)}
                  </span>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="mt-6 flex items-center justify-center gap-4" data-id="element-372" data-mp="10srljxokg4w0">
            <button type="button" onClick={() => go(-1)} aria-label={t(copy.testimonialPrev)} className="rounded-full border border-navy/15 p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-373" data-mp="vsdmh54y05a4">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-374" data-mp="37fh88pspbg65" />
            </button>
            <div className="flex items-center gap-2" data-id="element-375" data-mp="3cfd0xsvy7l6e">
              {testimonials.map((item, dot) => <button key={item.id} type="button" onClick={() => setIndex(dot)} aria-label={`${item.name}`} aria-current={dot === index} className={`h-2 rounded-full transition-colors duration-150 ease-out ${dot === index ? 'w-6 bg-royal' : 'w-2 bg-navy/20 hover:bg-navy/40'}`} data-id="element-376" data-mp="3gh6yvtereb2v" data-mpi={dot} />)}
            </div>
            <button type="button" onClick={() => go(1)} aria-label={t(copy.testimonialNext)} className="rounded-full border border-navy/15 p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-377" data-mp="20zwqutethrgs">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-378" data-mp="1gxtuxa8aycrf" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}